import React from 'react'

export default function Super_admin_dashboard() {
  return (
    <div>
      <h1>Hello Super Admin here</h1>
    </div>
  )
}
